<template>
  <div class="w-full">
    <div class="otp-input" :id="unicId">
      <input type="text" required autocomplete="one-time-code" />
      <input type="text" required autocomplete="one-time-code" />
      <input type="text" required autocomplete="one-time-code" />
      <input type="text" required autocomplete="one-time-code" />
      <input type="text" required autocomplete="one-time-code" />
    </div>
    <div class="hidden">
      <TextInput
        :value="inputText"
        ref="textInput"
        :required="required"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import TextInput from './TextInput.vue'
import { OTPInputHandler } from './otpInput/OTPInputHandler'

export default defineComponent({
  name: 'SelectInput',
  components: {
    TextInput,
  },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    preventKeyDown: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: '',
    },
    detailText: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeHolder: {
      type: String,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    alwaysShowPrefix: {
      type: Boolean,
      default: false,
    },
    alwaysShowSuffix: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Function,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      fileTypes: {
        png: 'image/png',
        jpg: 'image/jpg',
        jpeg: 'image/jpeg',
        pdf: 'application/pdf',
      },
      unicId: `component-${Date.now()}`,
      inputText: '',
    }
  },
  mounted() {
    this.initOtpHandler()
  },
  methods: {
    initOtpHandler() {
      const otpHandler = new OTPInputHandler(`#${this.unicId}>input`)
      otpHandler.onInputEvent(newValue => {
        this.inputText = newValue
      })
    },
    externalSetValue(newValue) {
      console.log(newValue)
    },
  },
  watch: {
    inputText(val) {
      this.$emit('input', val)
      this.$emit('input:modelValue', val)
      this.$emit('update:modelValue', val)
    },
  },
  computed: {},
})
</script>

<style scoped>
@import url(./assets/css/input.css);
@import url(./otpInput/style.css);
</style>